import axios from "axios"
import React, { useEffect, useState } from "react"
import { FaCloudDownloadAlt } from "react-icons/fa"
import { useHistory } from "react-router-dom"
import { Button, Spinner, Table } from "reactstrap"
import UploadProjectFiles from "./UploadProjectFiles"

const ProjectsData = ({ projectData, ProjectID, setAuth, userPermissions }) => {
  const history = useHistory()

  const [layout, setLayout] = useState("data-table")
  const [editing, setEditing] = useState(false)
  const [loading, setLoading] = useState(false)

  const [projectsDataList, setProjectsDataList] = useState([])
  const [projectDocs, setProjectDocs] = useState({
    IDI: [],
    AD: [],
    CD: [],
    SOIL: [],
    BOQ: [],
    CN: [],
    STR: [],
  })

  const fetchData = async () => {
    setLoading(true)

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID,
      Export: "1",
    }

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "api/amanat/PDDrive.php",
        formData
      )

      if (res.data.error === true && res.data.message === "Access denied!") {
        setAuth(true)
        setTimeout(() => {
          history.push("/logout")
          setTimeout(() => {
            history.push("/login")
          }, 1000)
        }, 4000)
      }

      setProjectsDataList(res.data.Files)
      setProjectDocs({
        IDI: res.data.IDI,
        AD: res.data.AD,
        CD: res.data.CD,
        SOIL: res.data.SOIL,
        BOQ: res.data.BOQ,
        CN: res.data.CN,
        STR: res.data.STR,
      })

      setLoading(false)
      return res.data.Zip // Return the URL
    } catch (err) {
      console.log("error------>", err)
      throw err
    }
  }

  const exportData = async () => {
    try {
      const downloadUrl = await fetchData()
      if (downloadUrl) {
        window.open(downloadUrl, "_self", "noopener,noreferrer")
      }
    } catch (error) {
      console.error("Export failed:", error)
    }
  }

  const uploadDataHandler = () => {
    setLayout("uploading")
  }

  useEffect(() => {
    fetchData()
  }, [editing])

  return (
    <>
      {loading ? (
        <div
          style={{ height: "300px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <Spinner type="border" size="lg" color="secondary" />
        </div>
      ) : (
        <div>
          {layout === "data-table" ? (
            <div className="table-responsive">
              <div className="mb-2 d-flex justify-content-end align-items-center">
                {(userPermissions.R34.P === "4" ||
                  userPermissions.R34.G === "1") && (
                  <Button className="mx-1" onClick={uploadDataHandler}>
                    Upload Data
                  </Button>
                )}

                <Button className="mx-1" onClick={exportData}>
                  Download All
                </Button>
              </div>

              <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
                <thead>
                  <tr>
                    <th scope="col" style={{ width: "20px" }}>
                      #
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col">Category</th>
                    <th scope="col">Size</th>
                    <th scope="col">By</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {projectsDataList.map((item, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>

                      <td>{item.File}</td>

                      <td>{item.Type}</td>

                      <td>{item.Size}</td>

                      <td>{item.UserName}</td>

                      <td>
                        <a
                          href={item.URL}
                          target="_blank"
                          rel="noreferrer"
                          style={{ all: "unset" }}
                        >
                          <FaCloudDownloadAlt
                            style={{
                              fontSize: "24px",
                              cursor: "pointer",
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <UploadProjectFiles
              projectData={projectData}
              projectDocs={projectDocs}
              ProjectID={ProjectID}
              setLayout={setLayout}
              setEditing={setEditing}
            />
          )}
        </div>
      )}
    </>
  )
}

export default ProjectsData
